import React, { Children } from 'react';
import { Footer } from '../components/Footer';
export const Privacy = () => {
  return <div className="flex flex-col min-h-screen" data-id="element-567" data-mp="2wk6wfj0w7vc2">
      <main className="py-16 md:py-24 relative flex-grow overflow-hidden" data-id="element-568" data-mp="2wlhzfgmikz24">
        {/* Background pattern - now using relative positioning */}
        <div className="absolute inset-0 bg-grid-gray-900/[0.02] -z-10" data-id="element-569" data-mp="36hbaevkl4khs" />
        {/* XL Cyan gradient blob */}
        <div className="absolute -left-[300px] top-[10%] w-[1400px] h-[1400px] bg-gradient-to-tr from-cyan-500/15 via-primary-300/10 to-cyan-200/15 rounded-[50%_50%_45%_55%] blur-3xl -z-10" data-id="element-570" data-mp="3k8gfweamw701" />
        {/* Background gradient blobs - contained within main content */}
        <div className="absolute top-0 right-1/3 w-[900px] h-[900px] bg-gradient-to-br from-cyan-400/10 via-cyan-400/10 to-blue-400/10 rounded-[60%_40%_55%_45%] blur-3xl -z-10" data-id="element-571" data-mp="3p8cjicff5wf2" />
        <div className="absolute top-[30%] -left-[200px] w-[800px] h-[800px] bg-gradient-to-tr from-purple-400/10 via-violet-400/10 to-fuchsia-400/10 rounded-[40%_60%_45%_55%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '2s'
      }} data-id="element-572" data-mp="1zvikn4frt4b3" />
        <div className="absolute top-[60%] right-0 w-[750px] h-[750px] bg-gradient-to-bl from-amber-400/10 via-orange-400/10 to-red-400/10 rounded-[55%_45%_60%_40%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '1.5s'
      }} data-id="element-573" data-mp="l4sxmf6gbeaf" />
        <div className="absolute bottom-0 left-1/4 w-[700px] h-[700px] bg-gradient-to-r from-emerald-400/10 via-green-400/10 to-cyan-400/10 rounded-[45%_55%_50%_50%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '3s'
      }} data-id="element-574" data-mp="uvnl1mvfojxg" />
        {/* Content container */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-575" data-mp="18tvc5e5sgr0p">
          <h1 className="text-4xl md:text-5xl font-serif font-normal text-cyan-900 mb-6 text-center" data-id="element-576" data-mp="1drdl34jt368p">
            Privacy Policy
          </h1>
          <div className="prose prose-lg max-w-none bg-white/80 backdrop-blur-sm rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-577" data-mp="3an317fb7emzs">
            <p className="text-gray-500 mb-8" data-id="element-578" data-mp="motadl4v4jbj">Last Updated: September 2026</p>

            <p className="mb-6 text-gray-700" data-id="element-579" data-mp="hq8ajmtiw1nm">
              At Teaching Lab Ventures, Inc. ("TLVI", "we", "our", "us"),
              privacy is important to us. This Privacy Policy describes how TLVI
              collects personally identifiable information ("PII") via the Site
              and Services, as such terms are defined in the End User License
              Agreement.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-580" data-mp="10p44qy5dsg1g">
              This Privacy Policy does not apply to the information that our
              business partners, including our network of foundations,
              districts, schools, coaches, and teachers, choose to manage,
              upload, and store in our Services ("Partner Content") for which we
              are a service provider/processor. In those circumstances, we
              process and/or host Partner Content on behalf of a business
              partner and that business partner is responsible for the
              collection and use of all Partner Content, including all necessary
              consents related to such Partner Content. The respective business
              partner's privacy notice will apply to the business partner's
              collection and use of such Partner Content and questions regarding
              such notice should be directed to such business partner.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-581" data-mp="1k8t7l353lhv9">
              By accessing or using the Website and Services or otherwise
              providing personal information to us via the Website and Services
              and contact us methods, you have consented to the terms of this
              Privacy Policy and consent to our privacy practices described
              herein, including our use and disclosure of your personal
              information. If you do not agree to the terms and conditions of
              this Privacy Policy, then please do not provide us with your
              personal information and do not access or use the Website and
              Services. Please note that if you choose to limit the information
              that you provide to us while using the Website and Services, you
              may not be able to use or participate in certain features of the
              Website and Services. If you have additional questions or require
              more information about our Privacy Policy, do not hesitate to
              contact us.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-582" data-mp="ajjhd7grhlw1">
              Information We Collect
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-583" data-mp="moi2mcnzhgp">
              As further described below, we collect personal information
              directly from you, automatically through your use of the Website
              and Services, and from other, third-party sources. To the extent
              permitted by applicable law, we may combine the information we
              collect from you with publicly available or data we receive from a
              third party.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-584" data-mp="27h76wwm7zz4z">
              <span className="font-semibold" data-id="element-585" data-mp="2c9qkhtkwqu9s">
                Personal Information We Collect Directly From You.
              </span>{' '}
              While the personal information we collect varies depending upon
              your use of the Website, Services, and our interactions with you,
              in general, we collect the following personal information directly
              from you:
            </p>
            <p className="mb-2 text-gray-700" data-id="element-586" data-mp="1tir3pfnkgqrl">
              <span className="font-semibold" data-id="element-587" data-mp="1yiltffvlvab2">Contact Information.</span> When
              you contact us, we collect your name, email address, phone number,
              and other contact information you choose to provide.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-588" data-mp="39wpmmjudcuf2">
              <span className="font-semibold" data-id="element-589" data-mp="39zljs5ye7f2g">Employment Information.</span>{' '}
              When you contact us, we collect information regarding the school
              or organization with whom you are associated.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-590" data-mp="2u8cd5fa2emtr">
              <span className="font-semibold" data-id="element-591" data-mp="2u71axjw9pn4r">
                Account Registration Information.
              </span>{' '}
              When you register for an account in the Services, we collect
              information on you in order to set up such account.
              This may include your name, email address, phone number, school or
              organization name, job title, location information including
              state/province and country, login name and password.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-592" data-mp="26g5cw517xvp2">
              <span className="font-semibold" data-id="element-593" data-mp="1is4cjje71lkq">
                Classroom Recordings (if applicable).
              </span>{' '}
              If your organization has enabled our Video Coaching feature, the
              Classroom Capture app records classroom teaching sessions so that
              teaching practice can be reviewed and coached. These recordings
              include video, audio, and transcripts, and may incidentally
              capture students' images and voices. We treat this content as
              personally identifiable information and use it solely to provide
              coaching (not to train AI models or for advertising), and limit
              access to authorized teachers, coaches, and leaders. To produce
              transcripts, the audio from a recording is sent to a
              speech-to-text provider (currently Deepgram) that transcribes it
              and redacts personal names before the transcript is returned to
              us. Transcripts and short excerpts of recordings may also be
              processed by our AI model providers to generate coaching
              feedback. All of these providers are listed on our{' '}
              <a href="/sub-processors" className="text-primary-600 hover:text-primary-800" data-id="element-594" data-mp="3jggzqnec5ps3">
                sub-processors page
              </a>{' '}
              and are bound by agreements that prohibit using this content to
              train their models. This content is Partner Content, and your
              organization is responsible for obtaining any necessary consents.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-595" data-mp="62cbc3d9sdvg">
              <span className="font-semibold" data-id="element-596" data-mp="6118c5rnfa5e">
                Payment Information (if applicable).
              </span>{' '}
              You may be required to provide financial and bank information
              prior to purchasing the Services. Please note, we do not store
              financial and bank information; such information is securely
              processed and stored by our payment processor. For more
              information regarding the payment processor's privacy practices,
              please review the policies provided by such provider.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-597" data-mp="sbjcemiwzkeg">
              <span className="font-semibold" data-id="element-598" data-mp="x9b87rmojqnx">
                Communications and Interactions.
              </span>{' '}
              When you send email, call, or otherwise communicate with us and
              with members of our team, we collect and maintain a record of your
              contact details, communications, and our responses.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-599" data-mp="1b8kjccw13ul1">
              <span className="font-semibold" data-id="element-600" data-mp="1g7x4mt794tli">Responses and Feedback.</span> If
              you participate in our surveys or questionnaires, we collect your
              responses and feedback, such as user satisfaction or other
              information related to your use of the Website and Services, and
              any other information you so choose to provide.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-601" data-mp="1yyoerwz2co0y">
              <span className="font-semibold" data-id="element-602" data-mp="1yzgad7snulr8">Marketing and Promotions.</span>{' '}
              We collect your email, name, phone number, preferences. If you
              participate in promotions we offer, we collect your name and other
              information related to the activities available through the
              Website and Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-603" data-mp="267g6fv91u7n2">
              <span className="font-semibold" data-id="element-604" data-mp="26893g4i7his0">Preferences.</span> We also may
              collect information about your preferences, including
              communications preferences.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-605" data-mp="2f5rv3rqcuvcv">
              The Services are designed to assist education professionals. While
              using the Services, you may upload teaching or coaching-related
              materials or interact with chat features. Please do not upload any
              personal information, including but not limited to student names,
              identification numbers, contact information, or any other data
              that could be used to identify an individual student. The Services
              are intended for use with de-identified or anonymized content
              only; they cannot be used to identify any individual student.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-606" data-mp="2za8xsh0wxapm">
              By using the Services, you agree not to input, store, or transmit
              any personal information or sensitive data. We are not responsible
              for any personal information that is uploaded in violation of this
              policy.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-607" data-mp="3mxh1wvmludq2">
              <strong data-id="element-608" data-mp="3hz5sgm08258d">Personal Information We Collect Automatically.</strong> We
              and our third-party providers automatically collect personal
              information related to your use of the Website and Services,
              including using cookies and other similar technologies. The
              personal data we may automatically collect includes the below
              categories of information (collective, "Usage Data"):
            </p>
            <p className="mb-2 text-gray-700" data-id="element-609" data-mp="281yxiu1yys6k">
              <strong data-id="element-610" data-mp="280xiyflqvnk3">Device and Browsing Information.</strong> When you visit
              the Website and Services, we may collect IP address, browser type,
              domain names, access times, date/time stamps, operating system,
              language, device type, unique ID, Internet service provider,
              referring and exiting URLs, clickstream data, and similar device
              and browsing information.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-611" data-mp="1bbyelboa75x6">
              <strong data-id="element-612" data-mp="1bd9doy6s7phy">Activities and Usage.</strong> We also collect activity
              information related to your use of the Website and Services, such
              as information about the links clicked, searches, features used,
              items viewed, time spent within the Website, your interactions
              with us within the Website and Services, and other activity and
              usage information.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-613" data-mp="mswlebyhiew1">
              <strong data-id="element-614" data-mp="ht1u47asrnag">Location Information.</strong> We may also collect or
              derive location information about you, such as through your IP
              address. If you choose to enable location-based sharing with us
              through your device settings, we may collect precise location
              information to provide content that is more relevant to your
              location and to otherwise improve your interactions with the
              Website and Services. You may turn off location data sharing
              through your device settings.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-615" data-mp="1age7pryzckrm">
              For more information about our use of cookies and other similar
              technologies, please see the "COOKIES AND OTHER TECHNOLOGIES"
              section below.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-616" data-mp="1kcqzgkaysojq">
              <strong data-id="element-617" data-mp="3dyceq16decus">
                Personal Information We Collect from Other Sources.
              </strong>{' '}
              In addition, we may collect and receive certain personal
              information from business partners, organizations, and public
              databases. As permitted by applicable law, we may combine this
              information with other personal information within our possession
              and will use it in accordance with the Privacy Policy.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-618" data-mp="2zx029zqf4tdn">
              Some of our Services allow you to provide us with personal
              information relating to other parties (collectively, "Third-Party
              Data"). If you use any feature of the Services that allows you to
              communicate with other parties (such as to refer another other
              party to the Services or to communicate with them), either by
              submitting Third-Party Data to the Services or otherwise
              permitting the Services to automatically access Third-Party Data
              in your possession, you acknowledge, represent, and agree (a) that
              you have the authority of the relevant other party for us to
              access and use the relevant Third-Party Data, and (b) that you
              have notified these other parties and informed them how their
              information is collected and used by us to provide the Services.
              We reserve the right to identify you as the person who has made
              the referral in any messages that are sent to other parties. We
              use Third-Party Data to (a) contact such party using the
              Third-Party Data provided, and/or (b) provide you with an editable
              template message designed to facilitate communication between you
              and such party through the Services. We may also send reminders or
              related messages to you and to other parties on your behalf from
              time to time, as and where permitted by applicable law.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-619" data-mp="3uaeuufto2ge6">
              How We Use Your Information
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-620" data-mp="3gjt9mkgqpud4">
              We use the personal information we collect in various ways,
              including to:
            </p>
            <p className="mb-2 text-gray-700" data-id="element-621" data-mp="d2b4wlw9l3gx">
              <strong data-id="element-622" data-mp="czf66vclearf">To Provide the Website and Services:</strong> To operate,
              deliver, and maintain the Website and Services and any other
              services you may request from us.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-623" data-mp="826p6y36kcrr">
              <strong data-id="element-624" data-mp="80vgqkysigub">To Monitor and Maintain the Website and Services:</strong>{' '}
              To monitor system performance, diagnose issues, administer and
              troubleshoot the Website and Services, analyze trends and usage
              patterns, and generate statistics.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-625" data-mp="2l7blt3n2s1xf">
              <strong data-id="element-626" data-mp="2ga20o06pycfe">To Respond to Your Requests:</strong> To answer your
              questions, fulfill your requests, and provide customer support.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-627" data-mp="2u8rvf962g00l">
              <strong data-id="element-628" data-mp="2p9yfzb77xyxs">To Communicate with You:</strong> We may send you
              marketing communications about the Services, promotions, and other
              information that may be of interest to you.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-629" data-mp="1xkllc6qdkfex">
              <strong data-id="element-630" data-mp="2bap1qh2kpewg">To Use Third-Party Data You Provide:</strong> If you
              provide information about third parties (such as to contact those
              third parties), we may use that information to facilitate
              communication, send reminders, and support other related features,
              as allowed by applicable law.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-631" data-mp="1dv1g169hxpbn">
              <strong data-id="element-632" data-mp="t9ren2mvoc3y">To Improve the Services:</strong> We may use your personal
              information to make the Services more stable and user-friendly,
              analyze service issues, improve the design and content of the
              Services, analyze how the Services are used, offer new services,
              and develop new Services and programs relating to the Services.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-633" data-mp="1c8vjs0batlqc">
              <strong data-id="element-634" data-mp="1c83nen9vnjz0">For Marketing and Audience Engagement:</strong> To analyze
              user engagement and improve how we communicate with users.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-635" data-mp="1l1p2k7pyf38y">
              <strong data-id="element-636" data-mp="1l304s33r42xy">To Provide Customer Service and Notices:</strong> To
              respond to your feedback and send administrative updates, legal
              notices, or changes to this Privacy Policy or our Terms.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-637" data-mp="1zx50intnnjam">
              <strong data-id="element-638" data-mp="1zvtvylsdy7ig">To Support Business Operations:</strong> For internal uses
              such as audits, market research, analytics, security, and
              performance monitoring.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-639" data-mp="3fiyvxnbv4wzr">
              <strong data-id="element-640" data-mp="3agzs6cc7ny2a">To Enforce Our Agreements:</strong> To uphold our Terms,
              this Privacy Policy, and any other agreements between you and us.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-641" data-mp="70symynifh78">
              <strong data-id="element-642" data-mp="6zrdu2gozgcb">To Promote Safety and Prevent Fraud:</strong> To help
              protect the security of the Services and users by detecting,
              preventing, and responding to fraud, abuse, unauthorized access,
              and other security-related issues.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-643" data-mp="3ogsnym2lh4h4">
              <strong data-id="element-644" data-mp="prk2xlsn4her">For Other Legitimate Purposes:</strong> Including:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-1" data-id="element-645" data-mp="pteq76rdwlm0">
              <li data-id="element-646" data-mp="kzak0ppy0hlz">
                Any other purpose for which you provide personal information;
              </li>
              <li data-id="element-647" data-mp="2bjl521co2rhf">
                Compliance with internal policies or legal/regulatory
                obligations;
              </li>
              <li data-id="element-648" data-mp="22khlyxdi2c2x">Any other use disclosed at the time of collection;</li>
              <li data-id="element-649" data-mp="22muc3xtevsr2">Any use with your consent;</li>
              <li data-id="element-650" data-mp="1xmy7bwcw3xag">Any other purpose described in this Privacy Policy.</li>
            </ul>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-651" data-mp="2ucfd0bbvhjc5">
              How We Disclose Your Information
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-652" data-mp="2qbdlyhs40dl9">
              Targeted or Personalized advertising (ads based on a user's
              personal information) is not used or displayed in the Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-653" data-mp="2giobnq8ap5ri">
              We may share your personal information for the purposes described
              above and as follows:
            </p>
            <p className="mb-2 text-gray-700" data-id="element-654" data-mp="397vc4urb85fe">
              <strong data-id="element-655" data-mp="3gkuivkru0u5e">Affiliates, Subsidiaries, and Sponsors.</strong> We may
              disclose the personal information we collect to our corporate
              affiliates and subsidiaries and sponsors.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-656" data-mp="3qhpf1x0muigi">
              <strong data-id="element-657" data-mp="3qkv276ppba9l">Vendors and Service Providers.</strong> We disclose the
              personal information we collect to service providers who perform
              functions on our behalf, such as regulatory compliance services,
              AI vendors, IT and website hosting, marketing, customer support,
              data storage, analysis and processing providers. For the current
              list of these providers and the data each one handles, see our{' '}
              <a href="/sub-processors" className="text-cyan-700 hover:text-cyan-800 underline underline-offset-2" data-id="element-658" data-mp="i2fif4fii5g4">
                sub-processors list
              </a>
              .
            </p>
            <p className="mb-2 text-gray-700" data-id="element-659" data-mp="r46j1uv73m34">
              <strong data-id="element-660" data-mp="2n6ibivpl8h5k">
                Foundations, Schools, Teachers, and Others at your direction.
              </strong>{' '}
              We disclose the personal information we collect to foundations,
              schools, teachers, and other educational partners with your
              consent and at your direction.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-661" data-mp="2s535wei5s6m3">
              <strong data-id="element-662" data-mp="36ur3p5r4sn52">Marketing and Analytics Providers.</strong> We may
              disclose your personal information, including your Usage Data, to
              marketing networks, data analytics providers, and other companies
              who provide marketing or analytics services on our behalf.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-663" data-mp="3avuh7llpi734">
              <strong data-id="element-664" data-mp="3ax5kzlf5jeu8">In Support of Business Transfers.</strong> If we or our
              affiliates are or may be acquired by, merged with, or invested in
              by another company, or if any of our assets are or may be
              transferred to another company, whether as part of a bankruptcy or
              insolvency proceeding or otherwise, we may disclose or transfer
              the personal information we have collected from you with or to the
              other company. We may disclose certain personal information as
              necessary prior to the completion of such a transaction or other
              corporate transactions such as a financing or restructuring, to
              lenders, auditors, and third-party advisors, including attorneys
              and consultants.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-665" data-mp="30ein4galv2j6">
              <strong data-id="element-666" data-mp="30ftyp2aaleku">Compliance and Legal Obligations.</strong> To comply with
              our legal and compliance obligations and to respond to the legal
              process. For example, we may disclose information in response to
              subpoenas, court orders, and other lawful requests by regulators
              and law enforcement, including responding to national security or
              law enforcement disclosure requirements.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-667" data-mp="8ygw296aucam">
              <strong data-id="element-668" data-mp="8zrya4k3jbzm">With our Professional Advisors.</strong> We share your
              personal information with our attorneys, auditors, and other
              professional advisors who are providing you or assisting us in
              providing you with the services, to comply with applicable legal
              and regulatory requirements, and to support us with the purposes
              described in this Privacy Policy.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-669" data-mp="3heabslst3jqm">
              <strong data-id="element-670" data-mp="3hf3aczhm32xo">Security and Protection of Rights.</strong> Where we
              believe doing so is necessary to protect us, our rights and our
              property, or the rights, property, and safety of others.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-671" data-mp="33f0zhx7q19rx">
              <strong data-id="element-672" data-mp="33gc2hutcedhz">Aggregate and Deidentified Information.</strong>{' '}
              Notwithstanding anything else in this Privacy Policy, we may use,
              disclose, and otherwise process aggregate and deidentified
              information related to our business and the Website and Services
              in accordance with applicable law.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-673" data-mp="1wx15n37w0q9a">
              <strong data-id="element-674" data-mp="1wvzr2ornxlmt">Other Disclosures.</strong> We may disclose personal
              information in other ways not described above, but will notify you
              and, if necessary, obtain your consent for any such disclosures
              that are not otherwise described above.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-675" data-mp="1953t19wm5u74">
              Cookies And Other Technologies
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-676" data-mp="gissu0cx5vau">
              Like many other websites, we and our third-party providers use
              cookies, pixel tags, and other technologies to collect Usage Data.
              We may allow third parties to collect this Usage Data on our
              behalf and to retain and use this Usage Data themselves. We use
              this Usage Data to, for example, analyze and understand how you
              access, use, and interact with us through the Website and
              Services, to identify and resolve bugs and errors in the Website
              and Services, to assess, secure, protect, optimize, and improve
              the performance of the Website and Services, for marketing
              purposes, analytics purposes, and to personalize content on the
              Website.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-677" data-mp="4hjg70iz2nz5">
              <strong data-id="element-678" data-mp="3vm007tfu0gro">Third Party Analytics.</strong> We use third party tools
              which are operated by third party companies to analyze ad traffic
              and usage of the Website. This data may be used for purposes
              including delivering banner advertisements and other advertising
              tailored to your interests when you visit certain websites.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-679" data-mp="2xtjknan2byx5">
              <strong data-id="element-680" data-mp="2xubh0nohi0oh">Google Analytics.</strong> We use Google Analytics on the
              Website to help us analyze traffic and improve services. For more
              information on Google Analytics' processing of personal
              information, please see{' '}
              <a href="https://www.google.com/policies/privacy/partners/" className="text-primary-600 hover:text-primary-800" data-id="element-681" data-mp="3ciz9um6y3waq">
                https://www.google.com/policies/privacy/partners/
              </a>
              . You may opt out of the use of Google Analytics here:{' '}
              <a href="https://tools.google.com/dlpage/gaoptout" className="text-primary-600 hover:text-primary-800" data-id="element-682" data-mp="37qeh7nzrzp8s">
                https://tools.google.com/dlpage/gaoptout
              </a>
              .
            </p>
            <p className="mb-2 text-gray-700" data-id="element-683" data-mp="42wb55xt9hyj">
              <strong data-id="element-684" data-mp="20597dbv8k2it">PostHog.</strong> We use PostHog Analytics on the Website
              and Services to help us analyze traffic and improve services. For
              more information on PostHog's processing of personal information,
              please see{' '}
              <a href="https://posthog.com/web-analytics" className="text-primary-600 hover:text-primary-800" data-id="element-685" data-mp="1qfpklv4ejoio">
                https://posthog.com/web-analytics
              </a>
              .
            </p>
            <p className="mb-6 text-gray-700" data-id="element-686" data-mp="2j20vpzpmx7tq">
              <strong data-id="element-687" data-mp="2e4r185ne25z1">Do Not Track.</strong> Currently, the Website does not
              recognize "Do-Not-Track" requests. You may, however, disable
              certain tracking by disabling cookies.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-688" data-mp="253kh7mlj6d11">
              Third Party Privacy Policies
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-689" data-mp="xoo3hoh5fiwi">
              The Website and Services may contain links to third-party sites or
              apps, or vice versa. This Privacy Policy does not apply to those
              third-party sites or apps. We recommend that you read the privacy
              statements of any other sites or apps that you visit, as we are
              not responsible for the privacy practices of those sites or apps.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-690" data-mp="3j4ywz0n4elvs">
              Data Integration &amp; Third-Party Services
            </h3>

            <h4 className="text-lg font-semibold text-gray-800 mt-6 mb-2" data-id="element-691" data-mp="3o5cvns2u0jh5">
              Google API Disclosure
            </h4>
            <p className="mb-6 text-gray-700" data-id="element-692" data-mp="xsrq32af0cx">
              Nisa's use and transfer of information received from Google APIs
              to any other app will adhere to the{' '}
              <a href="https://developers.google.com/terms/api-services-user-data-policy" className="text-primary-600 hover:text-primary-800" target="_blank" rel="noopener noreferrer" data-id="element-693" data-mp="22pp2vbkjm876">
                Google API Services User Data Policy
              </a>
              , including the Limited Use requirements.
            </p>

            <h4 className="text-lg font-semibold text-gray-800 mt-6 mb-2" data-id="element-694" data-mp="1y1k0d9a9ff3d">
              Google Drive Integration
            </h4>
            <p className="mb-6 text-gray-700" data-id="element-695" data-mp="1jdz0rpclfy07">
              Nisa allows you to integrate your Google Drive account to
              streamline your coaching workflow.
            </p>

            <p className="mb-2 text-gray-700" data-id="element-696" data-mp="2c2cz667lgwca">
              <strong data-id="element-697" data-mp="2h04oqtkro6db">Information We Access.</strong> If you grant permission,
              Nisa will have "read-only" access to your Google Drive files
              (drive.readonly). This allows the application to view, search, and
              extract text from documents, presentations, and PDFs that you
              explicitly share with the Nisa AI assistant or search for within
              the chat interface.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-698" data-mp="vnuvzeno5s7m">
              <strong data-id="element-699" data-mp="vkgsu476lez4">How We Use This Data.</strong> We use this access solely
              to provide AI-driven insights, summarize your meeting notes, or
              generate coaching supports based on your existing documents.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-700" data-mp="y1qcnwc4q94n">
              <strong data-id="element-701" data-mp="xzdtxgyjruqj">Data Retention.</strong> Content extracted from your
              Google Drive files is processed to generate AI responses. We do
              not use your Google Drive data to train generalized AI models.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-702" data-mp="ehize1z5trk">
              <strong data-id="element-703" data-mp="bll1pq4n534">User Control.</strong> You can disconnect your Google
              Drive account at any time through the Nisa settings menu or by
              revoking access in your{' '}
              <a href="https://myaccount.google.com/permissions" className="text-primary-600 hover:text-primary-800" target="_blank" rel="noopener noreferrer" data-id="element-704" data-mp="aakx7ia3piuv">
                Google Security settings
              </a>
              . Disconnecting will immediately terminate Nisa's ability to
              access your files.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-705" data-mp="bcfq6ontl7id">
              Your Privacy Choices
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-706" data-mp="g4pbfrdzpjeb">
              We make available several ways for you to manage choices about
              your personal information, including preferences regarding cookies
              and whether you want to receive marketing and promotional emails
              from us, and choices regarding your account and profile
              information.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-707" data-mp="3thizklktk5ol">
              <strong data-id="element-708" data-mp="3tkx2pw1b4ix3">Cookie Settings.</strong> To prevent cookies from tracking
              your activity on the Website or visits across multiple websites,
              you can set your browser to block certain cookies or notify you
              when a cookie is set; you can also delete cookies. The "Help"
              portion of the toolbar on most browsers will tell you how to
              prevent your device from accepting new cookies, how to have the
              browser notify you when you receive a new cookie, or how to delete
              cookies. Visitors to the Website who disable cookies will be able
              to browse the Website, but some features may not function.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-709" data-mp="2fizctngb6pyv">
              <strong data-id="element-710" data-mp="2fjqv5wkwar77">Marketing Communications.</strong>
            </p>
            <p className="mb-6 text-gray-700" data-id="element-711" data-mp="2ajcyfaoqv3oh">
              <strong data-id="element-712" data-mp="2ail2tzv5d5y7">Email.</strong> You can opt out of receiving marketing
              emails from us by using the unsubscribe feature in any such email
              we send you.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-713" data-mp="20njbcxdefrsg">
              Children's Information
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-714" data-mp="3uzq0z171ib4a">
              The Website is not intended for individuals under the age of 18
              and the TLVI does not knowingly collect any personal information
              from children under the age of 13 without verifiable parental
              consent. If you think that your child provided this kind of
              information via the Website, we strongly encourage you to contact
              us immediately and we will use our best efforts to promptly remove
              such information from our records.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-715" data-mp="3k7uttxrb55yh">
              International Users
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-716" data-mp="3abru0yjxhjep">
              The Website and Services are solely intended for individuals
              located within the United States and its territories and are
              subject to U.S. law. If you are located outside of the United
              States and its territories, please do not use the Website and
              Services. By utilizing the Website and Services, you consent to
              the transfer of your data to the United States and its maintenance
              in the United States. Please be aware that the data protection
              laws in the United States may differ from those in your country of
              origin.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-717" data-mp="2qpydxl0fa67y">
              Security
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-718" data-mp="35mz1rdfhth15">
              Information provided by or made accessible by you to us, including
              but not limited to personal information, to the extent maintained
              on our systems, is protected using reasonable steps to deter
              against the loss, misuse and alteration of the information to the
              extent under our control. Due to the nature of the Internet,
              computer networks, systems and other factors, we cannot guarantee
              that the information submitted to, maintained on, or transmitted
              from our systems or the Website will be completely secure. You are
              solely responsible for all data that you transmit or that relates
              to any activity you have undertaken using the Website and
              Services.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-719" data-mp="2q02v4c3qmbfj">
              Personal Data Retention
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-720" data-mp="2zrz44i7d3lyj">
              We retain your personal information for as long as required to
              satisfy the purpose for which it was collected and used unless a
              longer period is necessary for our legal obligations or to defend
              a legal claim.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-721" data-mp="3dqfd6fsp5oju">
              Data Rights
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-722" data-mp="1efnvx0xvdtv6">
              While we are not currently subject to any comprehensive consumer
              privacy laws (such as the California Consumer Privacy Act or
              similar laws in other jurisdictions), we are committed to
              respecting your privacy and will honor reasonable requests to
              access, correct, know, or delete personal information that may be
              associated with your use of the Website and Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-723" data-mp="x6v6e9t1cfey">
              Please note that any such requests are subject to applicable
              contractual obligations we have with our business partners (such
              as schools, districts, or educational institutions). In some
              cases, we may be required to refer your request to the
              organization that provided you access to the Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-724" data-mp="9fheu62pknv1">
              To submit a request regarding your personal information, please
              contact us as described below. We may need to verify your identity
              and the nature of your relationship with the Website and Services
              before processing your request.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-725" data-mp="29ii9i9hpd3ph">
              Contact Us
            </h3>
            <p className="mb-12 text-gray-700" data-id="element-726" data-mp="1vjikh0qa2mss">
              If you have any questions about this Privacy Policy, please email
              us at{' '}
              <a href="mailto:privacy@nisa.coach" className="text-primary-600 hover:text-primary-800" data-id="element-727" data-mp="2o63anxv0osur">
                privacy@nisa.coach
              </a>
              .
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-728" data-mp="2efqpq4jaixo3" />
    </div>;
};